/* eslint-disable jsx-a11y/label-has-associated-control */
import { User } from '@carbon/icons-react';
import { Toggle } from '@carbon/react';
import { defineMessages, useIntl } from 'react-intl';

import styles from './EventVisibilityToggle.module.scss';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';

const EventVisibilityToggle = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const { visibleForGuests } = values;

    const updateVisibility = () => {
        updateValues({
            visibleForGuests: !visibleForGuests,
        });
    };

    return (
        <div className={styles.container}>
            <label
                form="event-handler-form"
                id="event-visible-for-guests-toggle-label"
                htmlFor="event-visible-for-guests-toggle"
                className={styles.label}
            >
                <User />
                <span>{intl.formatMessage(messages.visibleForGuests)}</span>
            </label>
            <Toggle
                form="event-handler-form"
                aria-labelledby="event-visible-for-guests-toggle-label"
                onToggle={updateVisibility}
                toggled={visibleForGuests}
                labelA=""
                labelB=""
                id="event-visible-for-guests-toggle"
            />
        </div>
    );
};

const messages = defineMessages({
    visibleForGuests: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventVisibilityToggle.EventVisibilityToggle.visibleForGuests',
        defaultMessage: 'Widoczne dla parafian',
    },
});

export default EventVisibilityToggle;
